export const ProjectsBodyDescriptiveText = ({ txt }) => {
  return (
    <div className="projects-body-descriptive-text">
      <p>{txt}</p>
    </div>
  );
};
